export const OTA_SUB_TIERS = ['hobbyist', 'botanist'];

export const NOTIFICATION_SUB_TIERS = ['tinkerer', 'hobbyist', 'botanist'];

export const TIER_LABELS = {
  free: 'Free',
  tinkerer: 'Tinkerer',
  hobbyist: 'Hobbyist',
  botanist: 'Botanist',
};

export function canUseOta(subTier) {
  return OTA_SUB_TIERS.includes(subTier);
}

export function canUseNotifications(subTier) {
  return NOTIFICATION_SUB_TIERS.includes(subTier);
}